import {captureError} from '../../../../utils/log';

export default (state, action) => {
  switch (action.type) {
    case 'UPDATE_USERS':
      return {
        ...state,
        users: action.users,
        totalCount: action.totalCount,
        loading: false
      };
    case 'START_LOADING':
      return {
        ...state,
        loading: true
      };
    case 'ERROR':
      return {
        ...state,
        loading: false,
        error: true
      };
    default:
      captureError('Invalid action type on users reducer');
  }

  return false;
};
